import { RouteObject } from "react-router";
import field from "./_field_id";
import FieldPageCrumb from "./FieldPageCrumb";
import newField from "./new";
import { getResultSets } from "../../../../API/fields";

const routes: RouteObject = {
  id: "field",
  path: "field",
  handle: {
    Crumb: FieldPageCrumb,
  },
  loader: getResultSets,
  children: [newField, field],
};

export default routes;
